<template>
    <div class="templatePicker group p-20">

        <div style="display:block; background-color: #f00; width: 20px; height: 20px; display: none" v-cloak></div>

        <div class="clear"></div>

        <div class="design-options p-10 p-b-0 primarybg" style="display: none;">
            <div class="group">
                <div class="btn-group m-r-10" style="float:left;">
                    <button v-if="!$auth.user().vendor" :class="{'notactive primaryaltbg': ($route.params.type !== 'all')}" @click="fetchTemplates('all')" class="btn btn-outline-primary m-b-10 primaryborder">All Templates</button>
                    <button v-if="$auth.user().vendor" :class="{'notactive primaryaltbg': ($route.params.type !== 'vendor')}" @click="fetchTemplates('vendor')" class="btn btn-outline-primary m-b-10 primaryborder">{{ $auth.user().vendor.data.name }}</button>
                </div>

                <div class="selectwrap m-b-10 primaryaltborder" v-if="sizes.length > 1">
                    <span class="icon-arrow-down"></span>
                    <select class="sizeDropdown" v-on:change="filter('size', $event.target.value)">
                        <option value="0">Filter by Size</option>
                        <option v-for="size in sizes" :value="size.list_name" >{{ size.name }}</option>
                    </select>
                </div>

                <div class="checkwrap group">

                    <div class="left" v-if="hasUV">
                        <div class="checkbox m-r-15 m-b-10">
                            <input id="spot_uv_cbox" type="checkbox" v-model="$store.state.pickerState.spot_uv" v-on:change="filterSpotUV($event.target)">
                            <label for="spot_uv_cbox">
                                Spot UV
                            </label>
                        </div>
                    </div>

                    <div class="left" v-if="hasFoil">
                        <div class="checkbox m-r-15 m-b-10">
                            <input id="foil_cbox" type="checkbox" v-model="$store.state.pickerState.foil" v-on:change="filterFoil($event.target)">
                            <label for="foil_cbox">
                                Foil
                            </label>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="clear"></div>

        <div v-if="templates === null || templates.length < 1"></div>

        <div class="group row pickerContent">
            <transition :duration="{ enter: 250 }" enter-active-class="animated fadeInLeft " v-on:after-enter="setHeight">
                <ul v-if="categories.length > 0 && showSideNav === true" class="sideNav col-md-3 lineheight-3">
                    <li class="categoryList header py-1" @click="$store.state.selectedCategory = null;$router.push(`/templates/${$route.params.type}`)">
                        Categories
                    </li>
                    <li v-for="cat in categories" class="categoryList py-md-1" v-if="!cat.parent">
                        <router-link :to="'/templates/' +$route.params.type+ '/' + cat.id"
                            :class="{ 'active': (cat.id === $route.params.uuid) }"
                            class="parent">
                                {{ cat.name }}
                        </router-link>

                        <router-link
                            v-for="subcat in cat.subcategories.data"
                            :key="subcat.id"
                            :class="{ 'active': (subcat.id === $route.params.subcat) }"
                            class="child"
                            :to="'/templates/' +$route.params.type+ '/' + subcat.parent + '/subcategory/' + subcat.id">
                                {{ '- &nbsp;' + subcat.name }}
                        </router-link>
                    </li>
                </ul>
            </transition>
            <div :class="{ 'col-md-12': (categories.length < 1 || showSideNav === false), 'col-md-9': (categories.length > 0 && showSideNav === true) }">
                <!-- TEMPLATE HEADER -->
                <div class="row m-b-20">
                    <div class="col-lg-12">
                        <div class="design-options p-0 primarybg m-b-0" style="overflow: hidden;">
                            <transition enter-active-class="animated slideInLeft" leave-active-class="animated slideOutLeft">
                                <span v-if="categories.length > 0 && $store.state.config.hideSideNav !== true" class="icon-view-list btn btn-outline-primary toggle-cats" @click="toggleSideNav"></span>
                            </transition>
                            <ol class="breadcrumb left m-b-0">
                                <li>
                                    <a @click="category = null;$router.push(`/templates/${$route.params.type}`)">All Categories</a>
                                </li>
                                <transition :duration="{ enter: 250, leave: 250 }" enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
                                    <li :class="{'active' : ($route.params.uuid), 'white' : ($route.params.subcat)}" v-if="$route.params.uuid">
                                        <a @click="$router.push(`/templates/${$route.params.type}/${$route.params.uuid}`)">{{ fetchCategory($route.params.uuid).name }}</a>
                                    </li>
                                </transition>
                                <transition :duration="{ enter: 250, leave: 250 }" enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
                                    <li :class="{'active' : ($route.params.subcat)}" v-if="$route.params.subcat">
                                        <a @click="$router.push(`/templates/${$route.params.type}/${$route.params.uuid}/subcat/${$route.params.subcat}`)">{{ fetchCategory($route.params.subcat).name }}</a>
                                    </li>
                                </transition>
                            </ol>

                            <transition :duration="{ enter: 250, leave: 250 }" enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
                                <div class="pr-4 right rightNavBtns" v-if="$route.params.uuid && (checkSubcats($route.params.uuid) === false || $route.params.subcat) && templates !== null && templates.length > 0">
                                    <span class="icon-view-tile btn rnButton btn-outline-primary toggle-view mr-2" v-on:click='isList = !isList; isThumbnail = !isThumbnail' v-bind:class="{ active: isThumbnail }"></span>
                                    <span class="icon-menu btn rnButton btn-outline-primary toggle-view" v-on:click='isList = !isList; isThumbnail = !isThumbnail' v-bind:class="{ active: isList }"></span>
                                </div>
                            </transition>

                            <div class="pr-4 right rightNavBtns" v-if="$store.state.config.hideDeepLinks !== true">
                                <span class="icon-link rnButton btn btn-outline-primary toggle-view" @click.prevent="copyUrl"></span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- CATEGORY BLOCKS -->
                <transition :duration="{ enter: 250, leave: 250 }" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut" v-on:after-enter="setHeight">
                    <div class="row display-flex" v-if="!$route.params.uuid">
                        <div class="template col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="cat in categories" v-if="!cat.parent">
                            <div class="gal-detail thumb m-t-0 m-b-20 clearfix" @click.prevent="$router.push('/templates/' + $route.params.type + '/' + cat.id)">
                                <div v-if="cat.image" class="imgCategory" :style="'background-image: url(\'' + cat.image + '\')'"></div>
                                <h4 class="left m-t-10 m-b-0 templateTitle categoryTitle">
                                    <div>{{ cat.name }}</div>
                                </h4>
                            </div>
                        </div>
                    </div>
                </transition>

                <!-- SUBCATEGORY BLOCKS -->
                <transition :duration="{ enter: 250, leave: 250 }" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut" v-on:after-enter="setHeight">
                    <div class="row display-flex" v-if="$route.params.uuid && checkSubcats($route.params.uuid) != false && !$route.params.subcat">
                        <div class="template col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="cat in checkSubcats($route.params.uuid)">
                            <div class="gal-detail thumb m-t-0 m-b-20 clearfix" @click.prevent="$router.push('/templates/' + $route.params.type + '/' + $route.params.uuid + '/subcategory/' + cat.id)">
                                <div v-if="cat.image" class="imgCategory" :style="'background-image: url(\'' + cat.image + '\')'"></div>
                                <h4 class="left m-t-10 m-b-0 templateTitle categoryTitle">
                                    <div>{{ cat.name }} {{ cat.image }}</div>
                                </h4>
                            </div>
                        </div>
                    </div>
                </transition>

                <!-- LOADING -->
                <transition :duration="{ enter: 250, leave: 250 }" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut">
                    <div v-show="templates !== null && templates.length < 1" style="padding-top: 100px;">
                        <center>
                            <FulfillingBouncingCircleSpinner
                                :animation-duration="2500"
                                :size="45"
                                :color="'#232F4B'">
                            </FulfillingBouncingCircleSpinner>
                        </center>
                    </div>
                </transition>

                <!-- THUMBNAIL VIEW -->
                <transition :duration="{ enter: 250, leave: 250 }" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut" v-on:after-enter="setHeight">
                    <div v-show="isThumbnail && $route.params.uuid && (checkSubcats($route.params.uuid) === false || $route.params.subcat) && templates !== null && templates.length > 0" class="row display-flex">
                        <div :class="computedClass('template', [template.category_list, template.finished_height + 'x' + template.finished_width, template.foil, template.spot_uv])" class="col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="(template, index) in templates" @click.prevent="loadTemplate(index)"  @mouseenter="flip(index)" @mouseleave="flip(index)">
                            <div class="gal-detail thumb m-t-0 m-b-20 clearfix">
                                <div class="imgContainer relative animate">
                                    <img :src="template.previews[template.default_image]" alt="" :id="template.id" class="auto thumb-img animate">
                                </div>
                                <h4 class="left m-t-10 m-b-0 templateTitle">
                                    <div class="templateName">{{ template.name }}</div>
                                    <div class="templateDescription">{{ template.description }}</div>
                                    <span class="m-r-5 left" v-for="cat in template.categories.data">
                                        <small>{{ cat.name }} &nbsp;</small>
                                    </span>
                                    <span class="m-r-5 right">
                                        <small>{{ template.finished_width }} x {{ template.finished_height }}</small>
                                    </span>
                                </h4>
                            </div>
                        </div>
                    </div>
                </transition>

                <!-- LIST VIEW -->
                <transition :duration="{ enter: 250, leave: 250 }" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut" v-on:after-enter="setHeight">
                    <div class="row" v-show="isList && $route.params.uuid && (checkSubcats($route.params.uuid) === false || $route.params.subcat) && templates !== null && templates.length > 0" >
                        <div class="col-xs-12 col-sm-6" v-for="(template, index) in templates">
                            <div :class="computedClass('template', [template.category_list, template.finished_height + 'x' + template.finished_width, template.foil, template.spot_uv])" @click.prevent="loadTemplate(index)">
                                <div class="gal-detail listview thumb m-t-0 m-b-10">
                                    <div class="imgContainer">
                                        <img :src="template.previews[template.default_image]" alt="" style="height: 100%; width: auto">
                                    </div>
                                    <div class="text-left listview-text">
                                        <div class="vertical-align-ab animate description">{{ template.description }}</div>
                                        <h4 class="m-0 animate">
                                            <span class="text-primary">{{ template.name }}</span><br>
                                            <span class="m-r-5 text-muted" v-for="cat in template.categories.data">
                                                {{ cat.name }}
                                            </span>
                                            <span class="m-r-5 text-muted">
                                             /
                                            </span>
                                            <span class="m-r-5 text-muted">
                                                {{ template.finished_width }} x {{ template.finished_height }}
                                            </span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <div class="clear"></div>

        <nav class="mt-3" v-if="pagination.total_pages > 1 && $route.params.uuid && (checkSubcats($route.params.uuid) === false || $route.params.subcat) && templates !== null && templates.length > 0">
            <paginate
                :page-count="Number(pagination.total_pages)"
                :click-handler="paginateTemplates"
                :margin-pages="2"
                :initial-page="((this.$route.params.page) ? parseInt(this.$route.params.page - 1) : 0)"
                :force-page="((this.$route.params.page) ? parseInt(this.$route.params.page - 1) : 0)"
                :prev-text="'‹'"
                :next-text="'›'"
                :container-class="'pagination justify-content-center'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :next-link-class="'page-link'"
                :prev-link-class="'page-link'"
                ref="paginate">
            </paginate>
        </nav>

    </div>
</template>

<script>
/* global Helpers */
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
import { windowMessaging } from '@/components/mixins/windowMessaging'
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'
const { getCurrentVendorID } = require('./common/helpers')

export default {
    name: 'templatePicker',
    components: {FulfillingBouncingCircleSpinner},
    mixins: [windowMessaging],
    data () {
        return {
            filters: {
                product: null,
                size: null,
                spot_uv: null,
                foil: null,
                color: null
            },
            showUrlCopy: false,
            templates: null,
            hasUV: false,
            hasFoil: false,
            categories: [],
            type: 'all',
            category: null,
            subcategory: null,
            sizes: [],
            pagination: [],
            itemsPerPage: 24,
            isThumbnail: true,
            isList: false,
            showSideNav: false
        }
    },
    beforeMount () {
        this.showSideNav = (localStorage.getItem('showSideNav') === 'true') ? true : false
    },
    mounted () {
        Helpers.sytleInputs()
        this.createCategoryFilters()

        // Fetch & Cache Templates
        if (this.$store.state.templateList === null) {
            this.fetchTemplates()
        } else {
            this.setTemplates(this.$store.state.templateList)
        }
    },
    updated: function () {
        if (this.$refs.paginate !== undefined) {
            this.$refs.paginate.selected = this.$store.state.pickerPage - 1
        }
    },
    watch: {
        $route: function (newVal, oldVal) {
            if (newVal.name === 'template-category' && this.checkSubcats(newVal.params.uuid) === false) {
                this.fetchTemplates()
            } else if (newVal.name === 'template-subcat') {
                this.fetchTemplates()
            }
        }
    },
    computed: {
        url () {
            let url = this.$store.state.pageUrl
            let queryString = '?'
            if (this.$route.params.uuid) {
                queryString += 'category=' + this.$route.params.uuid
            }
            if (this.$route.params.subcat) {
                if (queryString !== '?') {
                    queryString += '&'
                }
                queryString += 'subcategory=' + this.$route.params.subcat
            }
            if (queryString === '?') {
                queryString = ''
            }
            return url + queryString
        }
    },
    methods: {
        fetchCategory (uuid) {
            for (var x in this.categories) {
                if (this.categories[x].id === uuid) {
                    return this.categories[x]
                } else if (this.categories[x].id === this.$route.params.uuid) {
                    for (var n in this.categories[x].subcategories.data) {
                        let subcat = this.categories[x].subcategories.data[n]
                        if (subcat.id === uuid) {
                            return subcat
                        }
                    }
                }
            }

            return {
                id: '',
                name: 'Loading...'
            }
        },
        checkSubcats (uuid) {
            for (var x in this.categories) {
                if (this.categories[x].id === uuid && this.categories[x].subcategories && this.categories[x].subcategories.data.length > 0) {
                    return this.categories[x].subcategories.data
                }
            }

            return false
        },
        setTemplates (data) {
            if (data.meta !== undefined) {
                this.pagination = data.meta.pagination
            }
            this.templates = data.data

            // Create Filters
            this.createSizeFilters()
            this.createSideFilters()
            if (this.$refs.paginate !== undefined) {
                this.$refs.paginate.selected = this.$store.state.pickerPage - 1
            }
        },
        loadTemplate (id) {
            let template = this.$store.state.template

            if (template !== null && template.id !== null && template.id !== this.templates[id].id) {
                swal({
                    title: 'Please Confirm',
                    html: 'Loading this template will cause any unsaved changes to the current template to be lost',
                    animation: true,
                    position: 'top',
                    useRejections: true,
                    width: 600,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'I Approve'
                }).then(() => {
                    this.injectTemplateStatus(id)
                    this.$store.commit('template', this.templates[id])
                    this.$store.commit('savedTemplate', null)
                    this.$store.commit('templateName', null)
                    this.$router.push(`/designer/${this.templates[id].id}`)
                })
            } else if (template !== null && template.id !== null && template.id === this.templates[id].id) {
                this.$router.push(`/designer/${template.id}`)
            } else {
                this.injectTemplateStatus(id)
                this.$store.commit('template', this.templates[id])
                this.$router.push(`/designer/${this.templates[id].id}`)
            }
        },
        fetchTemplates () {
            let currentTemplates = this.templates
            this.templates = []
            let url = null

            let type = this.$route.params.type
            let cat = this.$route.params.uuid
            let subcat = this.$route.params.subcat

            // Push URL
            let destination = '/templates'
            destination += ((type) ? '/' + type : '')

            destination += ((cat) ? '/' + cat : '')
            // destination += ((!cat && this.$route.params.uuid) ? '/' + this.$route.params.uuid : '')

            destination += ((subcat) ? '/subcategory/' + subcat : '')
            // destination += ((!cat && !subcat && this.$route.params.subcat) ? '/subcategory/' + this.$route.params.subcat : '')

            this.$router.push(destination)

            if (type === 'vendor' && this.$auth.user().vendor) {
                let currentVendorID = getCurrentVendorID(this.$auth.user(), this.url)
                url = '/templates/vendor/' + currentVendorID

                if (subcat) {
                    url += '/' + subcat
                } else if (cat) {
                    url += '/' + cat
                }

                url += '?include=userversions,productsettings,userslist&limit=' + this.itemsPerPage + '&page='
            } else if (type === 'personal') {
                url = '/templates/user?include=userversions,productsettings,userslist&limit=' + this.itemsPerPage + '&page='
            } else if (cat) {
                // type = 'all'
                let uuid = ((this.$route.params.subcat) ? this.$route.params.subcat : this.$route.params.uuid)
                url = '/templates/category/' + uuid + '?include=userversions,productsettings,userslist&limit=' + this.itemsPerPage + '&page='
            }

            if (url) {
                let requestUrl = url + ((this.$route.params.page) ? this.$route.params.page : 1)

                this.axios.get(requestUrl)
                .then(
                    response => {
                        if (response.data.data.length > 0) {
                            let templates = this.filterTemplates(response.data)
                            this.$store.commit('pickerUrl', url)
                            this.$store.commit('templateList', templates)
                            this.setTemplates(templates)
                        } else {
                            if (currentTemplates !== null) {
                                // Helpers.errorPop('Error', 'No templates available for this selection.')
                            }
                            this.templates = currentTemplates
                        }
                    }
                ).catch(function (error) {
                    Helpers.errorPop('Error', error)
                })
            } else {
                Helpers.errorPop('Error', 'Sorry, we can\'t load the templates for this category')
            }
        },
        injectTemplateStatus (id) {
            Object.keys(this.templates[id].files).forEach((key) => {
                this.templates[id].files[key].confirmed = false
            })
        },
        toggleSideNav () {
            this.showSideNav = (this.showSideNav === true) ? false : true
            localStorage.setItem('showSideNav', this.showSideNav)
        },
        computedClass (standard, extras) {
            let string = standard
            for (var i in extras) {
                string += ' ' + extras[i]
            }
            return string.replace('.', '')
        },
        setHeight () {
            // this.windowMsgTemplateResize($('.templatePicker').height(), $('.templatePicker').width())
            setTimeout(() => {
                this.windowMsgTemplateResize($('.templatePicker').height(), $('.templatePicker').width())
            }, 250)
        },
        filterTemplates (templates) {
            let templatedata = templates.data
            for (var key in templatedata) {
                if (templatedata[key].userslist.data !== undefined && templatedata[key].userslist.data.list.length > 0) {
                    if (!templatedata[key].userslist.data.list.includes(this.$auth.user().id)) {
                        templates.data.splice(key, 1)
                    }
                }
            }

            return templates
        },
        filter (type, value) {
            this.filters[type] = value

            let use = ''

            for (var key in this.filters) {
                if (this.filters[key] !== null && this.filters[key] !== '0') {
                    use += '.' + this.filters[key]
                }
            }

            if (use !== '' && value !== 'all') {
                $('.template').not(use).hide()
                $('.template').filter(use).slideDown('fast')
            } else {
                $('.template').slideDown('fast')
            }
            this.setHeight()
        },
        filterSpotUV (e) {
            if ($(e).is(':checked')) {
                this.filter('spot_uv', 'spot_uv')
            } else {
                this.filter('spot_uv', null)
            }
        },
        filterFoil (e) {
            if ($(e).is(':checked')) {
                this.filter('foil', 'foil')
            } else {
                this.filter('foil', null)
            }
        },
        createCategoryFilters () {
            // let added = []
            this.categories = []

            // Add category names to templates
            for (var i in this.templates) {
                let list = ''
                for (var x in this.templates[i].categories) {
                    if (this.templates[i].categories[x][0] !== undefined && this.templates[i].categories[x][0].name !== undefined) {
                        list += this.templates[i].categories[x][0].list_name + ' '
                    }
                }
                this.templates[i].category_list = list
            }

            // Fetch Category List
            let data = {}

            if (this.$auth.user().vendor && this.$route.params.type === 'vendor') {
                // if a vendor admin user is watching a children vendor send id of the children vendor to get categories from this vendor
                let currentVendorID = getCurrentVendorID(this.$auth.user(), this.url)

                data = {
                    vendors: [currentVendorID]
                }
            }

            if (this.$route.params.uuid && this.$route.params.type !== 'vendor') {
                data = {
                    categories: [this.$route.params.uuid]
                }
            }

            if (Object.keys(data).length > 0) {
                this.axios.post('/templates/categories/search?limit=500&exclude=subcategories.vendor,subcategories.site,subcategories.type,vendor,site,type', data)
                .then(
                    response => {
                        if (response.data.data.length > 0) {
                            this.categories = response.data.data
                            setTimeout(() => { this.setHeight() }, 100)
                        }
                    }
                ).catch(function (error) {
                    Helpers.errorPop('Error', error)
                })
            }

            if (this.$store.state.pickerState.category !== null) {
                let parent = this
                setTimeout(function () {
                    $('.productDropdown').val(parent.$store.state.pickerState.category)
                    parent.filter('product', parent.$store.state.pickerState.category)
                }, 1)
            }
        },
        createSizeFilters () {
            let added = []
            this.sizes = []

            for (var i in this.templates) {
                if (!added.includes(this.templates[i].finished_height + 'x' + this.templates[i].finished_width)) {
                    added.push(this.templates[i].finished_height + 'x' + this.templates[i].finished_width)
                    let height = String(this.templates[i].finished_height).replace('.', '')
                    let width = String(this.templates[i].finished_width).replace('.', '')
                    this.sizes.push({list_name: height + 'x' + width, name: this.templates[i].finished_height + '" x ' + this.templates[i].finished_width + '"'})
                }
            }

            if (this.$store.state.pickerState.size !== null) {
                let parent = this
                setTimeout(function () {
                    $('.sizeDropdown').val(parent.$store.state.pickerState.size)
                    parent.filter('size', parent.$store.state.pickerState.size)
                }, 1)
            }
        },
        createSideFilters () {
            this.hasUV = false
            this.hasFoil = false
            for (var i in this.templates) {
                this.templates[i].foil = ''
                this.templates[i].spot_uv = ''

                if (this.templates[i].foil_front === 1 || this.templates[i].foil_back === 1) {
                    this.templates[i].foil = 'foil'
                    this.hasFoil = true
                }
                if (this.templates[i].spot_uv_front === 1 || this.templates[i].spot_uv_back === 1) {
                    this.templates[i].spot_uv = 'spot_uv'
                    this.hasUV = true
                }
            }

            if ($('#spot_uv_cbox').is(':checked')) {
                this.filterSpotUV($('#spot_uv_cbox'))
            }
            if ($('#foil_cbox').is(':checked')) {
                this.filterFoil($('#foil_cbox'))
            }
        },
        paginateTemplates: function (pageNum) {
            let destination = '/templates'
            destination += ((this.$route.params.type) ? '/' + this.$route.params.type : '')
            destination += ((this.$route.params.uuid) ? '/' + this.$route.params.uuid : '')
            destination += ((this.$route.params.subcat) ? '/subcategory/' + this.$route.params.subcat : '')
            destination += '/' + pageNum

            this.$router.push(destination)
            this.$store.commit('pickerPage', pageNum)

            this.templates = []
            this.axios.get(this.$store.state.pickerUrl + pageNum)
            .then(
                response => {
                    this.pagination = response.data.meta.pagination

                    this.setTemplates(response.data)
                    this.$store.commit('templateList', response.data)
                }
            ).catch(function (error) {
                Helpers.errorPop('Error', error)
            })
            this.$refs.paginate.selected = (pageNum - 1)
        },
        copyUrl () {
            this.$copyText(this.url).then((e) => {
                swal({
                    type: 'success',
                    title: 'Link Copied!',
                    animation: true,
                    position: 'top'
                })
            }, (e) => {
                alert('Can not copy')
            })
        },
        flip (index) {
            let template = this.templates[index]
            if (template.previews[1]) {
                let current = template.previews[template.default_image]

                if (template.previews[0] === current) {
                    template.previews[0] = template.previews[1]
                    template.previews[1] = current
                } else {
                    template.previews[1] = template.previews[0]
                    template.previews[0] = current
                }
                this.$forceUpdate()
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.pickerContent {
    background: #f2f4f7;
    margin: 0;
    padding: 10px 0px;

    .searchBlock {
        input {
            width: 100%;
            margin-bottom: 20px;
            height: 42px;
            border-radius: 4px;
            border: none;
            padding: 0 10px;
        }
    }

    .rightNavBtns {
        margin: 7px 7px 0 0;
        span {
            padding: 11px 12px;
        }
    }

    .sideNav {
        cursor: pointer;
        color: #202A42;
        list-style: none;
        text-align: left;
        li {
            background: #fff;
            margin-bottom: 1px;
            padding: 0 0 0 14px;

            &.header {
                background: #202A42;
                color: #fff;
                height: 54px;
                line-height: 53px;
            }

            &:not(:first-child):hover {
                // background: #eaeaea;
            }

            &.active {
                border-left: 5px solid #202A42;
            }

            a.parent {
                display: block;
                color: #202A42;
                margin-left: -14px;
                padding-left: 14px;
                font-weight: 500;
                &.active {
                    border-left: 5px solid #202A42;
                    padding-left: 9px;
                }
            }

            a.child {
                display: block;
                margin-left: -14px;
                color: #202A42;
                border-top: 1px solid #f0f0f0;
                padding-left: 25px;
                background: #f8f8f8;

                &:hover {
                    background: #f0f0f0;
                }
                &.active {
                    border-left: 5px solid #202A42;
                    padding-left: 20px;
                }
            }
        }
        li:nth-child(2) {
            font-weight: 500;
        }
    }
    .breadcrumb{
        cursor: pointer;
        font-size: 1.05em;
        line-height: 34px;
        margin-left: 18px;
        li.active, li:hover{
            a {
                color: #BFD4F6;
            }
        }
        li:before{
            padding: 0;
            content: "";
        }
        li.active{
            &:before{
                padding: 0 5px;
                color: #849DC6;
                content: "/\A0";
            }
            &.white a{
                color: #fff;
            }
        }
    }
}

.toggle-view {
    padding: 6px 8px;
}

.toggle-cats {
    float: left;
    padding: 16px;
    margin: 0 0 0 0;
    font-size: 1.4em;
    color: #fff;
    background: none;
    border-right: 1px solid #525A6C;
    border-radius: 0;
}

.thumb {
    background-color: #fff;
    border-radius: 3px;
    margin-top: 30px;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    // width: $width;
    position: relative;
    overflow: hidden;
    h4{
        width: 100%;
        font-size: 15px;
    }
    button {
        position: absolute;
        top: -80px;
    }
    &:hover button {
        top: 16px;
    }
}

.thumb-img {
    border-radius: 2px;
    overflow: hidden;
    // width: $width;
}

.gal-detail {
    position: relative;
    cursor: pointer;
    top: 0px;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    transition: top .1s linear, box-shadow .2s;
    h4 {
        margin-top: 16px;
    }
    .imgContainer {
        span {
            display: none;
            z-index: 2;
            color: #202A42;
        }
    }
    .templateTitle {
        .templateDescription {
            display: none;
        }
    }
    &:hover {
        top: -5px;
        box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);
        .templateTitle {
            .templateName {
                display: none;
            }
            .templateDescription {
                display: block;
            }
        }
    }
    &.listview {
        min-height: 80px;
        padding-left: 100px;
        position: relative;
        display: table;
        width: 100%;
        .listview-text {
            display: table-cell;
            vertical-align: middle;
            .description {
                display: none
            }
        }
        .imgContainer {
            width: 80px;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            padding: 5px;
            img {
                max-height: 100%;
                max-width: 100%;
                object-fit: contain
            }
        }
        &:hover {
            h4{
                opacity: 0;
            }
            .description {
                display: block;
            }
            .imgContainer {
                img {
                    opacity: 1
                }
            }
        }
    }
}

.imgContainer {
    width: 100%;
    display: block;
    text-align: center;
    overflow: hidden;
    height: 220px;
    background:#f7f7f7;
    position:relative;

    .thumb-img {
        width: auto;
        max-width: 94%;
        max-height: 94%;
        border:1px solid #efefef;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
}
.imgCategory {
    width: 100%;
    display: block;
    text-align: center;
    height: 275px;
    position:relative;
    background-size: 100% auto;
    background-position: center;
}
.templateTitle {
    div {
        display: block;
        height: 48px;
        overflow: hidden;
        text-align: left;
    }
    span {
        &.left {
            cursor: pointer;
        }
        font-size: 18px;
    }
}
.categoryTitle {
    div {
        display: block;
        height: 74px;
        line-height: 64px;
        font-size: 1.3em;
        font-weight: bold;
        overflow: hidden;
        text-align: center;
    }
}
@-webkit-keyframes spin {
    0%  {-webkit-transform: rotate(0deg);}
    100% {-webkit-transform: rotate(360deg);}
}
.icon-loading1 {
    color: #bbbbbb;
    font-size: 2em;
    margin-top: 40px;
    position: absolute;
    -webkit-animation: spin .7s infinite linear;
}
</style>



// WEBPACK FOOTER //
// TemplatePicker.vue?a26a7f06